import type { Action } from '../action';

export enum EventTypeEnum {
  OnClick = 'onClick',
  OnMouseEnter = 'onMouseEnter',
  OnSubmit = 'onSubmit',
  OnChange = 'onChange',
  OnOpen = 'onOpen',
  OnLoad = 'onLoad',
  OnSave = 'onSave',
  OnRowSelect = 'onRowSelect',
  OnRowSelectionChange = 'onRowSelectionChange',
  OnRowHover = 'onRowHover',
  OnClickCell = 'onClickCell',
  OnRightClickCell = 'onRightClickCell',
  OnClose = 'onClose',
  OnCollapse = 'onCollapse',
  OnExpand = 'onExpand',
  OnToggle = 'onToggle',
  OnOutputChange = 'onOutputChange',
  OnDataPointClick = 'onDataPointClick',
  OnFileUpload = 'onFileUpload',
  OnSuccess = 'onSuccess',
  OnFailure = 'onFailure',
  OnFocus = 'onFocus',
  OnBlur = 'onBlur',
  OnFaceDetected = 'onFaceDetected',
  OnPhotoCapture = 'onPhotoCapture',
  OnRecordingStart = 'onRecordingStart',
  OnRecordingPause = 'onRecordingPause',
  OnRecordingReset = 'onRecordingReset',
  OnRecordingStop = 'onRecordingStop',
  OnRecordedFileCapture = 'onRecordedFileCapture',
  OnStepChange = 'onStepChange',
  OnMenuItemClick = 'OnMenuItemClick',
  OnReceiveNotification = 'onReceiveNotification',
  OnReceiveMQTTEvent = 'onReceiveMQTTEvent',
  OnSendMessage = 'onSendMessage',
  OnCaseCreated = 'onCaseCreated',
  OnOrderChange = 'onOrderChange',
  OnTimerExpire = 'onTimerExpire',
  OnTimerIntervalElapsed = 'onTimerIntervalElapsed',
  OnMarkerClick = 'onMarkerClick',
  OnPermissionDenied = 'onPermissionDenied',
  OnCurrentTimeChange = 'onCurrentTimeChange',
  OnButtonClick = 'onButtonClick',
  OnSelectItem = 'onSelectItem',
  OnMessageSent = 'onMessageSent',
  OnCitationClick = 'onCitationClick',
  OnDeleteComment = 'onDeleteComment',
  OnPageLoad = 'onPageLoad',
  OnPageFocus = 'onPageFocus',
  OnAddComment = 'onAddComment',
  OnAddReply = 'onAddReply',
  OnCreateSubIssue = 'onCreateSubIssue',
  OnCreateIssue = 'onCreateIssue',
  OnCreateProject = 'onCreateProject',
  OnCancel = 'onCancel',
  OnAttachmentClick = 'onAttachmentClick',
  OnScan = 'onScan',
  OnFilterChange = 'onFilterChange',
  OnClear = 'onClear',
  OnKeyboardShortcut = 'onKeyboardShortcut',
  OnPageChange = 'onPageChange',
  OnOzonetelInitialize = 'onOzonetelInitialize',
  OnPress = 'onPress',
  OnLongPress = 'onLongPress',
  OnPullDown = 'onPullDown',
  OnScrollVisibilityChange = 'onScrollVisibilityChange',
  OnCheckChange = 'onCheckChange',
  OnSwipeStart = 'onSwipeStart',
  OnSwipeEnd = 'onSwipeEnd',
  OnSwipeItem = 'onSwipeItem',
  OnImageClick = 'onImageClick',
  OnMessageReceived = 'onMessageReceived',
  OnSelectInterval = 'onSelectInterval',
  OnSignatureCapture = 'onSignatureCapture',
  OnStartDictation = 'onStartDictation',
  OnEndDictation = 'onEndDictation',
  OnFlip = 'onFlip',
  OnOpenCopilotCanvas = 'onOpenCopilotCanvas',
  OnCloseCopilotCanvas = 'onCloseCopilotCanvas',
  OnShareLocation = 'onShareLocation',
  OnComponentSelected = 'onComponentSelected',

  // Copilot
  OnEditChartDrawerToggle = 'onEditChartDrawerToggle',
  OnShowHistory = 'onShowHistory',
  OnExitVoiceMode = 'onExitVoiceMode',
  OnVoiceModeConnect = 'onVoiceModeConnect',
  OnAgentConnected = 'onAgentConnected',
  OnAgentDisconnect = 'OnAgentDisconnect',
  OnInsertMessage = 'onInsertMessage',
  OnVoiceModeConnectError = 'onVoiceModeConnectError',
  OnVoiceModeScreenshareFailed = 'onVoiceModeScreenshareFailed',
  OnManageSources = 'onManageSources',
  OnManageSkills = 'onManageSkills',

  // Calendar
  OnDragEvent = 'onDragEvent',
  OnDropEvent = 'onDropEvent',
  onDropBlock = 'onDropBlock',

  // Kanban
  OnDragItem = 'onDragItem',
  OnDropItem = 'onDropItem',

  // Records
  OnCitationChange = 'onCitationChange',

  // ContextualDialog
  OnClickAway = 'onClickAway',

  // CopilotHistory
  OnDeleteCase = 'onDeleteCase',
  OnArchiveCase = 'onArchiveCase',
  OnRenameCase = 'onRenameCase',
  OnSelectCase = 'onSelectCase',

  // AudioPlayer
  OnSeek = 'onSeek',

  // CopilotThread
  OnChangeViewType = 'onChangeViewType',

  // DatePicker
  OnMonthYearChange = 'onMonthYearChange',

  // Dictation
  OnLiveDictation = 'onLiveDictation',

  // Walkthrough lifecycle hooks
  OnWalkthroughPreStart = 'onWalkthroughPreStart',
  OnWalkthroughPreEnd = 'onWalkthroughPreEnd',

  // Drawer
  OnSnapIndexChange = 'onSnapIndexChange',

  //Carousel
  OnSlideClick = 'onSlideClick',
  OnSlideChange = 'onSlideChange',
  //Tag
  OnDismiss = 'onDismiss',

  // SkillEditor
  OnBack = 'onBack',

  // AxisList
  OnAddCustomField = 'onAddCustomField',
  OnUpdateView = 'onUpdateView',
}

export interface Event {
  /**
   * unique identifier for the event
   */
  id: string;
  /**
   * The event that triggers the action. This should correspond to a predefined set of events in the application.
   */
  eventType: string;

  action: Action;
  /**
   * The targetId by which the event will be triggered.
   * For example: In table where we have multiple UI elements for configuring actions for a single table block, we distinguish between them using targetId
   */
  targetId?: string;
  /**
   * Event is hidden and is not shown in the UI
   * For example: In Entity Form, Update Entity and Create Entity Events configuration are hidden from interactions Widget
   */
  hidden?: boolean;
  /**
   * Whether the event should be disabled or not. When disabled, the event and all its actions are skipped.
   */
  disabled?: boolean;
  /**
   * Event type payload data
   */
  payload?: Record<string, unknown>;
}

// visibility state for OnScrollVisibilityChange — fires when a tracked child block
// crosses the scrollable's visible-area edges (tri-state transitions)
export type VisibilityState = 'in_view' | 'above_view' | 'below_view';

export interface OnBlockVisibilityChangePayload {
  targetBlockId: string;
  visibilityState: VisibilityState;
}
